/* Filtro para formatação de NIRE - Número de Identificação de Registro de Empresa */
angular.module("avlib").filter('avNire', function () {
	return function(nire){
		if (nire != null){
			while (nire.length < 11){
				nire = "0"+nire;
			}
			return nire.substr(0,3)+"."+nire.substr(3,5)+"."+nire.substr(8,2)+"-"+nire.substr(10,1);
		}
		return null;
	};
});
